import Toaster, { showToast } from "../Toaster/Toaster";
import CareHiresLogo from "../../assets/img/CH_New_Logo.png";
import { Card, Form, Input, Button, Typography, Row } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./ResetPassword.css";
import { useState, useEffect } from "react";
import PasswordValid from "../../assets/img/password-valid.png";
import PasswordInvalid from "../../assets/img/password-invalid.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { passwordRules, validatePassword } from "../../utils/passwordRules";
const { Title, Text, Link } = Typography;

const ResetPassword: React.FC = () => {
  const [form] = Form.useForm();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [isValidated, setIsValidated] = useState(false);

  useEffect(() => {
    const formValues = form.getFieldsValue();
    setPassword(formValues.password || "");
    setConfirmPassword(formValues.confirmPassword || "");
  }, [form.getFieldValue("password"), form.getFieldValue("confirmPassword")]);

  const validatePasswordRequestToken = async (token: string) => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/password/validate-pw-reset`,
        { token: token }
      );
      return response.data;
    } catch (error: any) {
      showToast("Invalid token", { type: "error" });
      return;
    }
  };

  useEffect(() => {
    const validateToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token")?.trim() || "";
      if (!token) {
        showToast("Invalid token", { type: "error" });
        return;
      }

      if (!isValidated) {
        await validatePasswordRequestToken(token);
        setIsValidated(true);
      }
    };

    validateToken();
  }, [isValidated]);

  const onFinish = async (values: any) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token")?.trim() || "";
      if (!token) {
        showToast("Invalid token", { type: "error" });
        return;
      }
      const password = values.password;
      const response = await axios.post(
        `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth/users/password/reset-password`,
        { token: token, newPassword: password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        showToast("Password reset successfully", { type: "success" });
        if (response.data.data.userGroup === "Worker") {
          window.location.href = "https://onelink.to/h64vwc";
        } else {
          navigate("/login");
        }
      }
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        showToast(error.response.data.message, { type: "error" });
      } else {
        showToast(
          "There was an error processing your request. Please try again later.",
          { type: "error" }
        );
      }
    }
  };

  return (
    <>
      <div className="login-container" >
        <img
          className="login-title-main"
          src={CareHiresLogo}
          alt="CareHires Logo"
        />
        <Row justify="center" align="middle">
          <Card className="card-inline-height" style={{ height: '100%' }}>
            <Row>
              <Title level={2}>Reset your password</Title>
              <Text className="forgot-password-text">
                Enter a new password. Both fields must match in order to change your password.
              </Text>
            </Row>
            <Row style={{ height: '80%' }}>
              <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                className="forgot-password-form"
                onValuesChange={(_, values) => {
                  setPassword(values.password || "");
                  setConfirmPassword(values.confirmPassword || "");
                }}
              >
                <Form.Item
                  className="common-card-margin">
                  <Text className="placeholder-labels">Password</Text>
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ validator: validatePassword }]}
                >
                  <Input.Password placeholder="********" className="custom-input" />
                </Form.Item>

                <Form.Item
                  className="common-card-margin">
                  <Text className="placeholder-labels">Confirm Password</Text>
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  dependencies={["password"]}
                  rules={[
                    { required: true, message: "Please confirm your password!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject("Passwords do not match!");
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="********" className="custom-input" />
                </Form.Item>
                <Text className="terms">
                  By clicking the button above, you agree to our{" "}
                  <Link target="_blank" href="https://carehires.com/terms-conditions">
                    terms of use
                  </Link>{" "}
                  and our{" "}
                  <Link target="_blank" href="https://carehires.com/privacy-policy">
                    privacy policy
                  </Link>
                  .
                </Text>
                <Form.Item className="reset-password-margin">
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    className="forgot-password-button"
                  >
                    Reset Password
                  </Button>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </Row>
      </div >

    </>
  );
};

export default ResetPassword;
